<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="工厂:" label-width="100px">
                <el-select v-model="dataForm.werks" filterable clearable placeholder="请选择" @change="getDataList">
                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryCode" :value="item.factoryCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商名称:"  label-width="100px">
                <el-input size="small" v-model="dataForm.name1" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="结算单号:"  label-width="100px">
                <el-input size="small" v-model="dataForm.zjsdh" placeholder="结算单号" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="结算区间日期:" label-width="100px">
                <el-date-picker v-model="dataForm.deadlineDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @blur="getDataList">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <!-- <el-button size="small" plain type="primary" @click="exportPriceAgreementData()">
                    批量导出
                </el-button> -->
                <!-- <el-button size="small" v-if="isAuth('sourcing:settlement:newbutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button> -->
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                        导入订单
                    </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" style="width: 100%;" border :height="tableHeight" :header-cell-style="{background:'#f5f5f5'}" :default-expand-all="false">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="werks" header-align="center" align="center" label="工厂" width="50">
                </el-table-column>
                <el-table-column prop="name2" header-align="center" align="center" label="工厂名称" width="150">
                </el-table-column>
                <el-table-column prop="zjsdh" header-align="center" align="center" label="结算单号" width="150">
                </el-table-column>
                <el-table-column prop="ztype" header-align="center" align="center" label="结算单类型" width="100">
                    <template slot-scope="scope">
                        <span>
                            {{accountTypeFormat(scope.row.ztype)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="lifnr" header-align="center" align="center" label="供应商代码" width="100">
                </el-table-column>
                <el-table-column prop="name1" header-align="center" align="center" label="供应商名称" width="220">
                </el-table-column>
                <el-table-column prop="zhszje" header-align="center" align="center" label="含税总金额" width="100">
                </el-table-column>
                <el-table-column prop="zbhszje" header-align="center" align="center" label="不含税总金额" width="100">
                </el-table-column>
                <el-table-column prop="zbadutl" header-align="center" align="center" label="结算起始日期" :formatter="dateFormat" width="100">
                </el-table-column>
                <el-table-column prop="zbaduth" header-align="center" align="center" label="结算终止日期" :formatter="dateFormat" width="100">
                </el-table-column>
                <el-table-column prop="zkptzrq" header-align="center" align="center" label="开票通知日期" :formatter="dateFormat" width="100">
                </el-table-column>
                <el-table-column prop="zpub" header-align="center" align="center" label="发布日期时间" :formatter="dateTimeFormat" width="150">
                </el-table-column>
                <el-table-column prop="createdate" header-align="center" align="center" label="建立日期" :formatter="dateFormat" width="100">
                </el-table-column>
                <el-table-column prop="username" header-align="center" align="center" label="建立账号" width="100">
                </el-table-column>
                <el-table-column prop="zstatus" header-align="center" align="center" label="财务状态" width="100">
                    <template slot-scope="scope">
                        <span>
                            {{accountStatusFormat(scope.row.zstatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="left" width="85" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-edit">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    list,
    deleteBatch,
    // list
} from '@/controller/settlement'
import {
    getPurchaseOrgList,
    getFactoryList,
    getTaxCodeList
} from '@/controller/systemData'
import {
    getLabelByValue,
    ACCOUNT_TYPE_VALUE,
    ACCOUNT_STATUS_VALUE,
} from '@/utils/const'
import AddOrUpdate from './settlement-add-or-update'
import moment from 'moment'
//require('@/mock/mockSupplier');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            factoryList:[],//工厂数据集合
            dataForm: {
                lifnr: '',
                name1: '',
                zjsdh: '',
                zkptzrq: '',
                zhszje: '',
                zbhszje: '',
                werks: '',
                name2: '',
                ztype: '',
                payDate: '',
                deadlineDate:''
            },
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            getLabelByValue: getLabelByValue,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 280
            }
        }
    },
    components: {
        AddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        dateTimeFormat(row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        accountTypeFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(ACCOUNT_TYPE_VALUE, value)
        },
        // 通过code 获取结算单状态
        accountStatusFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(ACCOUNT_STATUS_VALUE, value)
        },
        // 新增或编辑子节点
        addChildHandle(id, parentId, parentName, parentNodePath) {

            console.log(id, parentId, parentName, parentNodePath)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
            })
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            list({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'werks': this.dataForm.werks,
                'name1': this.dataForm.name1,
                'zjsdh': this.dataForm.zjsdh,
                'zbadutl': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[0],//截止日区间开始
                'zbaduth': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[1]//截止日区间结束
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                this.getFactoryListVue()
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        //获取工厂的数据
        getFactoryListVue() {
            getFactoryList({
                post: '',
                address: '',
                factoryDesc: '',
                factoryCode: '',
            }).then((data) => {
                if (data && data.code === '00') {
                this.factoryList = data.body
                }
            })
        },
        //查询条件导出
        exportPriceAgreementData(){
            if(this.dataForm.priceAgreementCode === ''
                && this.dataForm.purchasePartya === ''
                && this.dataForm.partCode === ''
                && this.dataForm.factory === ''
                && this.dataForm.partybCode === ''
                && this.dataForm.syncStatus === ''
                && this.dataForm.procurementGroup === ''){
                 this.$message.error('请输入查询条件导出')
                 return
            }
            const params = {
                'priceAgreementCode': this.dataForm.priceAgreementCode,//SRM协议号
                'purchasePartya': this.dataForm.purchasePartya,//采购组织
                'partCode': this.dataForm.partCode,//物料号
                'factory': this.dataForm.factory,//工厂
                'partybCode': this.dataForm.partybCode,//供应商编码
                'syncStatus': this.dataForm.syncStatus,//是否同步
                'procurementGroup': this.dataForm.procurementGroup,//采购组
                'deadlineDateStart': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[0],//截止日区间开始
                'deadlineDateEnd': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[1]//截止日区间结束
            }
            exportPriceAgreement(params).then((data) => {
                if(data && data.code == '00') {
                    this.readAsBinaryString(data.body)
                    this.$message.success({
                        message: '操作成功',
                        type: 'success',
                        onClose: () => {
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        // // 新增 / 修改
        // addOrUpdateHandle(row) {
        //     console.log(row)
        //     this.addOrUpdateVisible = true
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
        //     })
        // },
        // 删除
        // deleteHandle(id) {
        //     console.log(id)
        //     this.$confirm(`确定进行删除操作?`, '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         deleteBatch([id]).then(data => {
        //             if (data && data.code === '00') {
        //                 this.$message({
        //                     message: '操作成功',
        //                     type: 'success',
        //                     duration: 1500,
        //                     onClose: () => {
        //                         this.getDataList()
        //                     }
        //                 })
        //             } else {
        //                 this.$message.error(data.msg)
        //             }
        //         })
        //     }).catch((e) => {
        //         console.log(e)
        //     })
        // }
    }
}
</script>
